/**
 * oh-variant-story.js
 * ---------------------------------------------------------------------------
 * Steuert die Sektion "Varianten-Story": pro Produktvariante ein Block
 * (Bild + Headline + Text). Beim Variantenwechsel wird der passende Block
 * eingeblendet, die anderen ausgeblendet.
 *
 * Hört auf Impacts "variant:change" (gefeuert vom Produkt-Form). Wir lauschen
 * auf document im CAPTURE-Modus -> erfasst das Event auch dann, wenn es nicht
 * bubbelt. Per Produkt-Varianten-IDs wird gefiltert, damit Events anderer
 * Produkte (z.B. Quick-Add in Empfehlungen) ignoriert werden.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  class VariantStory extends HTMLElement {
    connectedCallback() {
      this._items = Array.prototype.slice.call(this.querySelectorAll('[data-variant-id]'));
      var ids = (this.getAttribute('data-variant-ids') || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      this._productIds = ids.length
        ? ids
        : this._items.map(function (el) { return el.getAttribute('data-variant-id'); });

      this._onVariantChange = this._onVariantChange.bind(this);
      document.addEventListener('variant:change', this._onVariantChange, true);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange, true);
    }

    _onVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var id = String(variant.id);
      // Nur reagieren, wenn das Event zu DIESEM Produkt gehört.
      if (this._productIds.indexOf(id) === -1) return;
      this._show(id);
    }

    _show(id) {
      var matched = false;
      this._items.forEach(function (el) {
        var isMatch = el.getAttribute('data-variant-id') === id;
        el.hidden = !isMatch;
        if (isMatch) matched = true;
      });
      // Hat die Variante keinen Story-Block, wird die Sektion ausgeblendet.
      this.hidden = !matched && this._items.length > 0;
    }
  }

  if (!customElements.get('variant-story')) {
    customElements.define('variant-story', VariantStory);
  }
})();
